<div class="candidate-main-info">
  <section class="cv-section">
    @if (mainSkillList?.length) {
      <div
        class="skills-block no-splittable-block"
        data-base="30"
        data-min="42"
        data-line="12"
        data-gap="9">
        <h4 class="section-title">Skills</h4>
        <div class="skills-block__container">
          @for (mainSkill of mainSkillList; track mainSkill) {
            <span class="skills-block__item bolder">
              {{ mainSkill }}
            </span>
          }
        </div>
      </div>
    }
    @if (secondarySkillList?.length) {
      <div
        class="skills-block no-splittable-block"
        data-base="20"
        data-min="32"
        data-line="12"
        data-gap="9">
        <h4 class="section-sm-title">Other Skills</h4>
        <div class="skills-block__container">
          @for (secondarySkill of secondarySkillList; track secondarySkill) {
            <span class="skills-block__item bolder">
              {{ secondarySkill }}
            </span>
          }
        </div>
      </div>
    }
    @if (profile?.languages?.length) {
      <div class="skills-block no-splittable-block">
        <h4 class="section-sm-title">Languages</h4>
        <div class="skills-block__container">
          @for (language of profile.languages; track language) {
            <span class="skills-block__item">
              <span class="bolder">
                {{ language.language | emojiCleaner }}
              </span>
              @if (language.level) {
                ({{ 'LEVELS.' + language.level | translate }})
              }
            </span>
          }
        </div>
      </div>
    }
  </section>

  @if (profile?.positions) {
    <section class="cv-section">
      <h4 class="section-title no-splittable-block">Work Experience</h4>
      @for (position of profile.positions; track position) {
        <div class="experience-block no-splittable-block">
          <div class="experience-block__header">
            <div class="experience-block__row">
              <span class="position">
                {{ position.positionTitle | emojiCleaner }}
              </span>
              <app-time
                class="experience-duration"
                [duration]="position.duration"
                [extraClass]="'small'"></app-time>
            </div>
            <div class="experience-block__row">
              <span class="company-name">
                {{ position.companyName | emojiCleaner }}
                @if (position.location) {
                  — {{ position.location | location }}
                }
              </span>
              <span class="experience-period">
                {{ position.duration | durationPeriod: 'full' : 'en' }}
              </span>
            </div>
          </div>
          <div class="experience-block__content">
            {{ position.description | emojiCleaner }}
          </div>
        </div>
      }
    </section>
  }
  @if (profile?.educations) {
    <section class="cv-section">
      <h4 class="section-title no-splittable-block">Education</h4>
      @for (education of profile.educations; track education) {
        <div class="experience-block no-splittable-block">
          <div class="experience-block__header">
            <div class="experience-block__row">
              <span class="position">
                {{ education.degreeName | emojiCleaner }}
              </span>
              <app-time
                class="experience-duration"
                [duration]="education.duration"
                [extraClass]="'small'"></app-time>
            </div>
            <div class="experience-block__row">
              <span class="company-name">
                {{ education.schoolName | emojiCleaner }}
              </span>
              <span class="experience-period">
                {{ education.duration | durationPeriod: 'full' }}
              </span>
            </div>
          </div>
          <div class="experience-block__content">
            {{ education.fieldOfStudy | emojiCleaner }}
          </div>
        </div>
      }
    </section>
  }
  @if (profile?.certifications) {
    <section class="cv-section">
      <h4 class="section-title no-splittable-block">Courses</h4>
      @for (certificate of profile.certifications; track certificate) {
        <div class="experience-block no-splittable-block">
          <div class="experience-block__header">
            <div class="experience-block__row">
              <span class="position">
                {{ certificate.certName | emojiCleaner }}
              </span>
              <app-time
                class="experience-duration"
                [duration]="certificate.duration"
                [extraClass]="'small'"></app-time>
            </div>
            <div class="experience-block__row">
              <span class="company-name">
                {{ certificate.authority | emojiCleaner }}
              </span>
              <span class="experience-period">
                {{ certificate.duration | durationPeriod: 'full' }}
              </span>
            </div>
          </div>
        </div>
      }
    </section>
  }
</div>
